/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Invite_Super_Admin_TitleInputs */



/**
* | output |
* | --- |
* | "Invite an administrator" |
*
* @param {Partner_Admin_Invite_Super_Admin_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_invite_super_admin_title = /** @type {((inputs?: Partner_Admin_Invite_Super_Admin_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Invite_Super_Admin_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Administrator einladen")
	return /** @type {LocalizedString} */ ("Invite an administrator")
});